<mat-card class="dashboard-card">
  <mat-card-header>
    <mat-card-title>
      {{title}}

<!--      <button pButton class="more-button p-button-text p-button-sm" [icon]="'fa fa-'+(expand?'compress':'expand')"-->
<!--              (click)="onExpandCard()" pTooltip="{{'common.'+(expand?'minimize':'maximize') | translate}}"></button>-->
<!--      <button mat-icon-button class="more-button" [matMenuTriggerFor]="menu" aria-label="Toggle menu">-->
<!--        <mat-icon>more_vert</mat-icon>-->
<!--      </button>-->
<!--      <mat-menu #menu="matMenu" xPosition="before">-->
<!--        <button class="expand-button" mat-menu-item (click)="onExpandCard()">{{expandLabel}}</button>-->
<!--        &lt;!&ndash;button mat-menu-item>Remove</button&ndash;&gt;-->
<!--      </mat-menu>-->
    </mat-card-title>
  </mat-card-header>
  <mat-card-content class="dashboard-card-content">
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
